import {
  Bundle,
  BundleWithoutId,
  ProductionArtifactsContext,
  ProductionOutputParameters,
  ProductionOutputType,
} from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getForProductionGroup(productionGroupGuid: string): Promise<readonly Bundle[]> {
  return DesignService.get(`public/bundles/forProductionGroup/${productionGroupGuid}`);
}

export function getForScheduleGroup(scheduleGroupGuid: string): Promise<readonly Bundle[]> {
  return DesignService.get(`public/bundles/forScheduleGroup/${scheduleGroupGuid}`);
}

export function bulkUpdate(bundles: readonly Bundle[]): Promise<void> {
  return DesignService.put(`public/bundles/bulkUpdate`, { data: bundles });
}

export function insert(bundle: BundleWithoutId): Promise<Bundle> {
  return DesignService.post('public/bundles', { data: bundle });
}

export function remove(bundleGuid: string): Promise<void> {
  return DesignService.delete(`public/bundles/${bundleGuid}`);
}

export function finishComponentsForBundles(bundleGuids: readonly string[]): Promise<void> {
  return DesignService.post('public/bundles/finishComponentsForBundles', { data: bundleGuids });
}

export function downloadProductionArtifacts(
  bundleGuids: readonly string[],
  productionOutputTypes: readonly ProductionOutputType[],
  productionArtifactsContext: ProductionArtifactsContext,
  productionOutputParameters: ProductionOutputParameters,
) {
  return DesignService.fetchFile('public/bundles/downloadProductionArtifacts', {
    post: true,
    data: { bundleGuids, productionOutputTypes, productionArtifactsContext, productionOutputParameters },
  });
}

export function assignToTruckload(bundleGuids: readonly string[], truckloadGuid: string) {
  return DesignService.post<readonly Bundle[]>('public/bundles/assignToTruckload', {
    data: { bundleGuids, truckloadGuid },
  });
}

export function removeFromTruckload(bundleGuid: string) {
  return DesignService.post<Bundle>(`public/bundles/removeFromTruckload/${bundleGuid}`);
}

export function assignToScheduleGroup(bundleGuids: readonly string[], scheduleGroupGuid: string) {
  return DesignService.post<readonly Bundle[]>('public/bundles/assignToScheduleGroup', {
    data: { bundleGuids, scheduleGroupGuid },
  });
}

export function removeFromScheduleGroup(bundleGuid: string) {
  return DesignService.post<Bundle>(`public/bundles/removeFromScheduleGroup/${bundleGuid}`);
}

export function assignToScheduleLineGroup(bundleGuids: readonly string[], scheduleLineGroupGuid: string) {
  return DesignService.post<readonly Bundle[]>('public/bundles/assignToScheduleLineGroup', {
    data: { bundleGuids, scheduleLineGroupGuid },
  });
}

export function removeFromScheduleLineGroup(bundleGuid: string) {
  return DesignService.post<readonly Bundle[]>(`public/bundles/removeFromScheduleLineGroup/${bundleGuid}`);
}
